export const environment = {
  martinTileUrl: 'https://verizon-tiles.instantgis.cloud/cell_towers_mvt/{z}/{x}/{y}',
  martinProjectTowersUrl: 'https://verizon-tiles.instantgis.cloud/project_towers_mvt/{z}/{x}/{y}',
  martinProjectSubscribersUrl: 'https://verizon-tiles.instantgis.cloud/project_subscribers_mvt/{z}/{x}/{y}',
  martinCensusUnitsUrl: 'https://verizon-tiles.instantgis.cloud/census_units_mvt/{z}/{x}/{y}',
  martinOsmUrl: 'https://verizon-tiles.instantgis.cloud/massachusetts/{z}/{x}/{y}',
  martinBuildingsUrl: 'https://verizon-tiles.instantgis.cloud/massachusetts_buildings/{z}/{x}/{y}',
  seedTowerOperator: 'verizon',
  towerDisplayOperator: 'verizon',
  towerElevationScale: 1,
  geoapifyEnabled: true,
  geoapifyApiKey: '277fa533bc1746e0bc3497787d7b5d3a',
  sionnaApiUrl: 'https://verizon-backend-api.instantgis.cloud',
  vsubBaselineJobType: 'runpod_pipeline_v2_scene_prep',
  metabaseBaseUrl: 'https://metabase.instantgis.cloud',
  metabaseDashboards: {
    projectInventory: '/dashboard/2',
    projectDetail: '/dashboard/9',
    scenarioInventory: '/dashboard/3',
    scenarioDetail: '/dashboard/4',
    executiveCompare: '/dashboard/6',
    engineeringCompare: '/dashboard/7',
    runCompare: '/dashboard/5',
    runPrbu: '/dashboard/15',
    runPrbuSectorDetail: '/dashboard/16',
    runPrbuSubscriberDelta: '/dashboard/17',
    jobTimingDetail: '/dashboard/13',
    jobTimingHistory: '/dashboard/18',
    verizonIngestPrepost: '/dashboard/10',
  },
};

